import { render, staticRenderFns } from "./WizardNewbornChild.vue?vue&type=template&id=6826f41f&"
import script from "./WizardNewbornChild.vue?vue&type=script&lang=js&"
export * from "./WizardNewbornChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports